import { createUseStyles } from "react-jss";

export default createUseStyles((theme: any) => ({
    radio: {
        display: "inline-block",
        userSelect: "none",
        background: "transparent",
    },
    radioGridCell: {
        composes: "radio__grid-cell",
        display: "flex",
        height: theme.GridCellMinHeight,
        margin: -theme.GridCellPadding,
        alignItems: "center",
        justifyContent: "center",

        "&:hover, &:focus": {
            color: theme.PrimaryColor,
        },
    },
    radioGridCellChecked: {
        composes: "radio__grid-cell--checked",
        color: theme.PrimaryColor,
    },
    radioInput: {
        composes: "radio__input",
        display: "none",
    },
}));
